import { render, staticRenderFns } from "./ultraCode.vue?vue&type=template&id=0e88d802&scoped=true&"
import script from "./ultraCode.vue?vue&type=script&lang=js&"
export * from "./ultraCode.vue?vue&type=script&lang=js&"
import style0 from "./ultraCode.vue?vue&type=style&index=0&id=0e88d802&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e88d802",
  null
  
)

export default component.exports